export default "__VITE_ASSET__a44b1a55__"